import { Phone, Send } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "./Reveal";
import {
  WA_DEFAULT,
  PHONE_CALL_TEL,
  PHONE_WHATSAPP_DISPLAY,
  PHONE_CALL_DISPLAY,
} from "./data";
import { WhatsAppIcon } from "./WhatsAppIcon";
import { ContactForm } from "./ContactForm";

const ChannelCard = ({ href, external, testId, icon, title, number, hoverCls, iconCls, tail }) => (
  <a
    href={href}
    target={external ? "_blank" : undefined}
    rel={external ? "noopener noreferrer" : undefined}
    data-testid={testId}
    className={`group flex items-center justify-between border border-line bg-card p-5 transition-colors duration-200 ${hoverCls}`}
  >
    <span className="flex items-center gap-4">
      <span className={`flex h-11 w-11 items-center justify-center border border-line transition-colors ${iconCls}`}>
        {icon}
      </span>
      <span>
        <span className="block font-display text-lg font-bold uppercase tracking-wide text-white">{title}</span>
        <span className="block font-mono text-xs tracking-[0.15em] text-ash">{number}</span>
      </span>
    </span>
    {tail}
  </a>
);

export default function Contact() {
  return (
    <section id="contact" className="relative bg-coal py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl gap-14 px-5 lg:grid-cols-2 lg:gap-20 lg:px-8">
        <Reveal>
          <Eyebrow>Contact Us</Eyebrow>
          <SectionTitle>
            Let&rsquo;s Build Your <span className="text-edge">Fitness Space</span>
          </SectionTitle>
          <p className="mt-6 max-w-md text-base leading-relaxed text-ash sm:text-lg">
            Share your space and budget — for a gym, studio, hotel, institution
            or home — and our team will plan the right Hercules Fitness setup
            around it.
          </p>

          <div className="mt-10 space-y-4">
            <ChannelCard
              href={WA_DEFAULT}
              external
              testId="contact-whatsapp-cta"
              icon={<WhatsAppIcon className="h-5 w-5" />}
              title="WhatsApp Us"
              number={PHONE_WHATSAPP_DISPLAY}
              hoverCls="hover:border-wa"
              iconCls="text-wa group-hover:border-wa"
              tail={<Send size={16} className="text-dim transition-colors group-hover:text-wa" />}
            />
            <ChannelCard
              href={`tel:${PHONE_CALL_TEL}`}
              testId="contact-call-cta"
              icon={<Phone size={18} />}
              title="Call Us"
              number={PHONE_CALL_DISPLAY}
              hoverCls="hover:border-edge"
              iconCls="text-edge group-hover:border-edge"
              tail={<Phone size={16} className="text-dim transition-colors group-hover:text-edge" />}
            />
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
